import { cmsDataService } from '@/common/services/cms.data.service'

export const getCinemaGroups = () => {
    return cmsDataService.get().cinemaGroups || []
}
